import { Button, Checkbox, FormControlLabel, Grid2, Typography } from "@mui/material";
import { MRT_BottomToolbar as MRTBottomToolbar, MRT_TableInstance } from "material-react-table";
import { useTranslation } from "react-i18next";

type ServiceTableBottomToolbarProps = {
  table: MRT_TableInstance<any>;
  isMandatory: boolean;
  isDisabled: boolean;
  setIsMandatory: (m: boolean) => void;
  handleAssign: () => void;
  onClose: () => void;
};

export function ServiceTableBottomToolbar({
  table,
  isMandatory,
  isDisabled,
  setIsMandatory,
  handleAssign,
  onClose
}: Readonly<ServiceTableBottomToolbarProps>) {
  const { t } = useTranslation();

  return (
    <Grid2>
      <Grid2>
        <MRTBottomToolbar table={table} />
      </Grid2>

      <Grid2 textAlign={"end"} sx={{ mt: 3, mb: 1 }}>
        <FormControlLabel
          data-testid="change-isMandatoryForService-control"
          sx={{ pr: 1 }}
          disabled={isDisabled}
          onChange={() => setIsMandatory(!isMandatory)}
          control={<Checkbox checked={isMandatory} />}
          label={<Typography fontWeight={600}>{t("Mandatory")}</Typography>}
        />

        <Button data-testid="cancel-btn" onClick={onClose} color="secondary" sx={{ mr: 2 }}>
          {t("Cancel")}
        </Button>
        <Button data-testid="save-btn" onClick={handleAssign}>
          {t("Save")}
        </Button>
      </Grid2>
    </Grid2>
  );
}
